import Vue from 'vue'
import config from '@/config'
import axios from 'axios'
import alertHelper from '@/helpers/alert'

const state = {
  // Under current house
  keys: [],
}

const getters = {
  getHouseId: (state) => {
    return state.house_id
  },
  getKeys: (state) => {
    return state.keys
  },
}

const mutations = {
  set(state, keys) {
    state.keys = keys
  },
  upsert(state, key) {
    console.log('Keys/upsert', {key})
    const existing = state.keys.find(k => k.id === key.id);
    if (existing) {
      Object.assign(existing, key)
    } else {
      state.keys.push(key)
    }
  },
}

const actions = {
  async fetchKeys(context) {
    try {
      const selectedHouse = context.rootGetters['HouseList/getSelectedHouse']
      if (!selectedHouse || !selectedHouse.id) {
        context.commit('set', []);
        return;
      }
      const response = await axios.get(config.apiBaseUrl + 'key', {
        params: {
          house_id: selectedHouse.id,
        },
      })

      if (response.data.errno === 0) {
        const keys = response.data.data
        context.commit('set', keys)
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async upsertKey(context, key) {
    try {
      const response = await axios.post(config.apiBaseUrl + 'key', key)
      if (response.data.errno === 0) {
        context.commit('upsert', response.data.data)
        console.log('upsert', response.data.data)
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
}

const storeModule = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default storeModule
